import { Component, OnInit, Input } from '@angular/core';
import { ActivatedRoute, Data } from '@angular/router';

import { Lead } from '../../../../shared/lead';
import { BrandService } from '../../../../services/brand.service';
import { FruHttpService } from '../../../../services/fru-http.service';
import { OfficeStatus } from '../../../../shared/office-status';

@Component({
  selector: 'buy-within-90',
  templateUrl: './buy-within-90.component.html',
  styleUrls: ['./buy-within-90.component.scss']
})
export class BuyWithin90Component implements OnInit {
  @Input() lead: Lead;
  public officeStatus: OfficeStatus;
  public currentYear: number = 2023;

  constructor(private fruHttp: FruHttpService, private route: ActivatedRoute, public brandService: BrandService) { }

  ngOnInit() {
    let d = new Date();
    this.currentYear = d.getFullYear();

    this.route.queryParams.subscribe(params =>
      this.fruHttp
        .getOfficeStatus(params.utm_source || 'within90_campaign')
        .subscribe(officeStatus => this.officeStatus = officeStatus)
      );

    this.getLead();

    this.route.queryParams.subscribe(params =>
      this.fruHttp
        .getOfficeStatus(params.utm_source || 'within90_campaign')
        .subscribe(officeStatus => this.officeStatus = officeStatus)
    );
  }

  getLead() {
    const id = this.route.snapshot.paramMap.get('id');
    const leadType: string = this.route.snapshot.data.type || '';

    if (!id) {
      this.redirectToMainForm();
    }

    this.fruHttp.getLead(id, leadType).subscribe(lead => {
      this.lead = lead;

      if (this.lead === null) {
        this.redirectToMainForm();
      } else {
        let params: any = this.route.snapshot.queryParams;
        if (params.utm_source) {
          this.lead.adnetwork = params.utm_source;
        }
        this.lead.medium = params.utm_medium || '';
        this.lead.campaign = id; // Store the encrypted id
      }
    });
  }

  redirectToMainForm() {
    const isKarmaRunning = typeof window !== 'undefined' && (window as any).__karma__;
    if (!isKarmaRunning) {
      this.fruHttp.redirectMainForm();
    }
  }
}
